import { ScrollArea } from '@mantine/core';
import React from 'react';
import { IResource, Office } from '@gettactic/api';
import ListHourRules from '@/components/hours/rule/ListHoursRules';

export interface HoursPanelProps {
  office: Office;
  resources?: IResource[] | null;
}

export const HoursPanel = ({ office, resources }: HoursPanelProps) => {
  return resources ? (
    <ScrollArea type="auto" offsetScrollbars className="h-full">
      <ListHourRules
        title="Custom Hours"
        office={office}
        resources={resources}
      />
    </ScrollArea>
  ) : null;
};
